export default "__VITE_ASSET__B62l_e8W__"